"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VarsContract = exports.ContractValueTypeHandler = void 0;
exports.isContractValueType = isContractValueType;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _variable = require("../variable");
var _chains = require("@blockwell/chains");
const VarsContractSymbol = Symbol.for("VarsContract");
class VarsContract {
  static isVarsContract(val) {
    return val && val[VarsContractSymbol];
  }
  constructor(data) {
    (0, _defineProperty2.default)(this, "abi", void 0);
    (0, _defineProperty2.default)(this, "address", void 0);
    (0, _defineProperty2.default)(this, "bwtype", void 0);
    (0, _defineProperty2.default)(this, "bwver", void 0);
    (0, _defineProperty2.default)(this, "contractName", void 0);
    (0, _defineProperty2.default)(this, "features", void 0);
    (0, _defineProperty2.default)(this, "id", void 0);
    (0, _defineProperty2.default)(this, "name", void 0);
    (0, _defineProperty2.default)(this, "network", void 0);
    (0, _defineProperty2.default)(this, "parameters", void 0);
    (0, _defineProperty2.default)(this, VarsContractSymbol, true);
    if (data) {
      Object.assign(this, data);
    }
  }
  toString() {
    return this.name || this.address;
  }
}
exports.VarsContract = VarsContract;
function isContractValueType(val) {
  return (val === null || val === void 0 ? void 0 : val.type) === "contract";
}
class ContractValueTypeHandler {
  constructor() {
    (0, _defineProperty2.default)(this, "type", "contract");
  }
  value(val) {
    return val.value;
  }
  truthy(val) {
    var _val$value;
    return !!((_val$value = val.value) !== null && _val$value !== void 0 && _val$value.address);
  }
  address(val) {
    var _val$value2;
    return (_val$value2 = val.value) === null || _val$value2 === void 0 ? void 0 : _val$value2.address;
  }
  readPath(val, path) {
    return (0, _variable.readReferencePath)(val.value, path);
  }
  stringValue(val) {
    var _val$value3;
    return (_val$value3 = val.value) === null || _val$value3 === void 0 ? void 0 : _val$value3.address;
  }
  equals(val, other, otherHandler) {
    if (isContractValueType(other)) {
      var _val$value4, _other$value, _val$value5, _other$value2;
      if ((0, _chains.chainEqual)((_val$value4 = val.value) === null || _val$value4 === void 0 ? void 0 : _val$value4.network, (_other$value = other.value) === null || _other$value === void 0 ? void 0 : _other$value.network) && (0, _chains.addressEqual)((_val$value5 = val.value) === null || _val$value5 === void 0 ? void 0 : _val$value5.address, (_other$value2 = other.value) === null || _other$value2 === void 0 ? void 0 : _other$value2.address)) {
        return true;
      }
    } else if (otherHandler.address) {
      var _val$value6;
      return (0, _chains.addressEqual)((_val$value6 = val.value) === null || _val$value6 === void 0 ? void 0 : _val$value6.address, otherHandler.address(other));
    }
    return false;
  }
}
exports.ContractValueTypeHandler = ContractValueTypeHandler;
//# sourceMappingURL=ContractValueTypeHandler.js.map